module.exports = __webpack_public_path__ + "dist/media/logo--nl.48b2f402.svg";